import React, { useState, useEffect } from "react";
import {
  viewPackage,
  deletePackage,
} from "../../../ReduxStore/Slice/Pricing/PackageSlice";
import { useDispatch } from "react-redux";
import Datatable from "../../../ExtraComponents/ReusableTable2";
import { useNavigate, useLocation } from "react-router-dom";
import { PenLine, Trash2 } from "lucide-react";
import sweatalert from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Config from "../../../Utils/Config";
import {
  DateConvertWithTime,
  roundNumber,
  compareText,
  compareNumber,
  applicableList,
} from "../../../Utils/CommonFun";

const Packages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [getPackageData, setPackageData] = useState([]);
  const [InputValue, setInputValue] = useState("");
  const [activetab, setActivetab] = useState("");
  const [initialized, setInitialized] = useState(false);

  const location = useLocation();
  const { state } = location;

  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const handleTabChange = (event) => {
    setActivetab(event.target.value);
  };
  useEffect(() => {
    if (state) {
      const { packageType, search } = state;

      if (packageType !== undefined) {
        setActivetab(packageType);
      }

      if (search) {
        setInputValue(search);
      }
    }

    setInitialized(true);
  }, [state]);

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue]);

  useEffect(() => {
    if (loading) {
      sweatalert.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      sweatalert.close();
    }
  }, [loading]);

  useEffect(() => {
    if (initialized) {
      getAllPackage();
    }
  }, [currentPage, pageSize, InputValue, activetab, initialized]);

  const getAllPackage = async () => {
    setLoading(true);

    const req = {
      agent_id: agent_id,
      page: currentPage,
      limit: pageSize,
      search: InputValue,
      status: activetab,
    };

    try {
      const response = await dispatch(viewPackage(req)).unwrap();
      if (response.status) {
        setPackageData(response.data);
        setTotalRecords(response?.pagination?.total || 0);
      } else {
        setPackageData([]);
      }
    } catch (error) {
      console.error("Error fetching package data:", error);
      setPackageData([]);
    } finally {
      setLoading(false);
    }
  };

  const deletePackageRow = async (row) => {
    sweatalert
      .fire({
        title: "Are you sure?",
        text: "You want to delete this package! ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const req = { id: row.id, agent_id: agent_id };
          await dispatch(deletePackage(req))
            .unwrap()
            .then((response) => {
              if (response.status) {
                sweatalert.fire({
                  title: "Success",
                  text: "Package Deleted Successfully",
                  icon: "success",
                  timer: 7000,
                  timerProgressBar: true,
                });
                getAllPackage();
              }
            })
            .catch((error) => {
              console.error("Error deleting package:", error);
            });
        } else if (result.dismiss === sweatalert.DismissReason.cancel) {
          return;
        }
      });
  };

  const handleExport = async () => {
    let totalData = getPackageData;
    const req = { agent_id: agent_id, page: 1, limit: 0, search: InputValue };

    await dispatch(viewPackage(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data;
        } else {
          sweatalert.fire({
            icon: "warning",
            title: "No Data",
            text: "No data to export!",
          });
          return;
        }
      })
      .catch((error) => {
        sweatalert.fire({
          icon: "warning",
          title: "No Data",
          text: "No data to export!",
        });
        return;
      });

    if (totalData.length === 0) {
      sweatalert.fire({
        icon: "warning",
        title: "No Data",
        text: "No data to export!",
      });
      return;
    }

    // export format
    const exportData = totalData?.map((row) => ({
      "Package Name": row?.name,
      Status: Number(row?.status) === 1 ? "Active" : "Inactive",
      Applicable: row?.applicable,
      "Total Cost of Service": roundNumber(row?.cost_service_price),
      "Default Price": roundNumber(row?.default_price),
      "Default Discount": row?.default_discount,
      "Minimum Price": roundNumber(row?.min_price),
      "Maximum Discount": row?.max_discount,
    }));

    downloadCSV(exportData, "Package Details.csv");
  };

  const downloadCSV = (data, filename) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));
    data.forEach((row) => {
      const values = headers.map((h) => `"${row[h] || ""}"`);
      csvRows.push(values.join(","));
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
  };

  const handleExportPDF = async () => {
    setLoading(true);
    let totalData = getPackageData;
    const req = { agent_id: agent_id, page: 1, limit: 0, search: InputValue };

    await dispatch(viewPackage(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data;
        } else {
          setLoading(false);
          sweatalert.fire({
            icon: "warning",
            title: "No Data",
            text: "No data to export!",
          });
          return;
        }
      })
      .catch((error) => {
        setLoading(false);
        sweatalert.fire({
          icon: "warning",
          title: "No Data",
          text: "No data to export!",
        });
        return;
      });

    if (totalData.length === 0) {
      setLoading(false);
      sweatalert.fire({
        icon: "warning",
        title: "No Data",
        text: "No data to export!",
      });
      return;
    }

    // export format
    const formattedData = totalData?.map((row, index) => ({
      s_no: index + 1,
      name: row?.name,
      status: Number(row?.status) === 1 ? "Active" : "Inactive",
      applicable: row?.applicable,
      cost_service_price: roundNumber(row?.cost_service_price),
      default_price: roundNumber(row?.default_price),
      default_discount: (row?.default_discount),
      min_price: roundNumber(row?.min_price),
      max_discount: (row?.max_discount),
    }));

    const columns = [
      { label: "S.No", key: "s_no" },
      { label: "Package Name", key: "name" },
      { label: "Status", key: "status" },
      { label: "Applicable", key: "applicable" },
      { label: "Total Cost", key: "cost_service_price" },
      { label: "Default Price", key: "default_price" },
      { label: "Default Discount", key: "default_discount" },
      { label: "Minimum Price", key: "min_price" },
      { label: "Maximum Discount", key: "max_discount" },
    ];

    try {
      const res = await axios.post(
        Config.base_url + "export-contract-pdf",
        { data: formattedData, columns: columns, title: "Package List" },
        { responseType: "blob" },
      );
      setLoading(false);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Package_Details.pdf";
      a.click();
    } catch (error) {
      setLoading(false);
      sweatalert.fire({
        icon: "error",
        title: "Export Failed",
        text: "Error exporting PDF",
      });
    }
  };

  const columns = [
    {
      name: "Package Name",
      cell: (row) => (
        <a
          href={`#/admin/pricing/view-package?id=${row.id}`}
          className="text-pink font-bold"
          style={{
            fontWeight: "bold",
          }}
          onClick={(e) => {
            if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
              e.preventDefault();
              navigate("/admin/pricing/view-package", {
                state: { row },
              });
            }
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.name}
        </a>
      ),
      selector: (row) => row.name,
      sortable: true,
      sortFunction: (a, b) => compareText(a.name, b.name),
      width: "150px",
    },
   
    {
      name: "Applicable",
      selector: (row) => applicableList(row.applicable).join(", "),
      // the chips need one wrapping div to stack in: a `cell` renders straight
      // into the flex cell, whereas a `selector` used to get wrapped for us
      cell: (row) => (
        <div style={{ width: "100%", overflow: "hidden" }}>
          {applicableList(row.applicable).map((item) => (
            <div className="applicable-data" key={item}>
              {item}
            </div>
          ))}
        </div>
      ),
      sortable: true,
      sortFunction: (a, b) =>
        compareText(
          applicableList(a.applicable).join(", "),
          applicableList(b.applicable).join(", "),
        ),
      width: "150px",
    },
    {
      name: <div>Total Cost of Service</div>,
      selector: (row) => roundNumber(row.cost_service_price),
      sortable: true,
      sortFunction: (a, b) =>
        compareNumber(a.cost_service_price, b.cost_service_price),
      width: "190px",
    },
    {
      name: <div>Default Price</div>,
      selector: (row) => roundNumber(row.default_price),
      sortable: true,
      sortFunction: (a, b) => compareNumber(a.default_price, b.default_price),
      width: "150px",
    },
    {
      name: <div>Default Discount</div>,
      selector: (row) => (row.default_discount),
      sortable: true,
      sortFunction: (a, b) =>
        compareNumber(a.default_discount, b.default_discount),
      width: "170px",
    },
    {
      name: <div>Minimum Price</div>,

      selector: (row) => roundNumber(row.min_price),
      sortable: true,
      sortFunction: (a, b) => compareNumber(a.min_price, b.min_price),
      width: "150px",
    },
    {
      name: <div>Maximum Discount</div>,
      selector: (row) => (row.max_discount),
      sortable: true,
      sortFunction: (a, b) => compareNumber(a.max_discount, b.max_discount),
    },

    // {
    //   name: (
    //     <div>
    //       Qualifying Conditions
    //     </div>
    //   ),
    //   selector: (row) => Number(row.qualifying_condition) === 1 ? "Active" : "Inactive",
    //   sortable: true,
    // },
    {
      name: "Action",
      cell: (row) => (
        <>
          <div
            className="d-flex justify-content-start"
            style={{ width: "150px" }}
          >
            <PenLine
              onClick={() =>
                navigate("/admin/pricing/edit-package", { state: { row: row } })
              }
            />
            {row?.deleted && <Trash2 onClick={() => deletePackageRow(row)} />}
          </div>
        </>
      ),
      sortable: false,
    },
  ];


    const showPagination  = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

  return (
    <div>
      <section className="section dashboard">
        <div className="row mb-3">
          <div className="col">
            <h4 className="page-title">
              <button
                className="btn p-0 fs-5"
                onClick={() => navigate("/admin/pricing/package")}
              >
                <i className="bx bx-arrow-back text-pink pe-1"></i>
              </button>
              All Packages
            </h4>
          </div>
          <div className="col-auto align-self-center">
            {getPackageData?.length > 0 && (
              <>
                <button
                  className="btn-outline-pink btn me-2"
                  onClick={handleExportPDF}
                >
                  <i className="ri-download-2-line"></i> Export PDF
                </button>
                <button
                  className="btn-outline-pink btn me-2"
                  onClick={handleExport}
                >
                  <i className="ri-download-2-line"></i> Export CSV
                </button>
              </>
            )}
          </div>
        </div>

        <div className="package-table">
          <div className="row">
            <data className="col-lg-3 datatable-search">
              <input
                type="text"
                className="search p-2 icon"
                placeholder="Search here"
                value={InputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </data>

            <div className="col-lg-3 filter-select mb-3 select_tab">
              <select
                className="form-select"
                value={activetab}
                onChange={handleTabChange}
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <div className="table-main-div">
            <Datatable columns={columns} data={getPackageData} filter={false} />
            {getPackageData.length > 0 ? (
              <div>
                {
                   showPagination > 1 && (
                    <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={
                    pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
                   )
                }
                

                <div className="mt-0">
                  <select
                    // className="perpage-select"
                    className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                    value={pageSize}
                    onChange={handlePageSizeChange}
                  >
                    {/* <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option> */}
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Packages;
